import styled from 'styled-components';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const StoryPersonImageWrapper = styled(Box)`
  border-radius: 50%;
  overflow: hidden;
  width: 50px;
  height: 50px;
`;

export const OurStoryColumns = styled(Columns)`
  ${themeMediaQuery('sm')} {
    max-width: 100%;
  }
  ${themeMediaQuery('md')} {
    max-width: 75rem;
  }
  ${themeMediaQuery('xl')} {
    max-width: 90rem;
  }
`;

export const OurStoryImageColumn = styled(Columns.Column)``;

export const OurStortImageContainer = styled(Box)`
  position: relative;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledOurStoryImage1 = styled(CloudImage)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  border-radius: 0px 0px 0px 40px;
  ${themeMediaQuery('sm')} {
    width: 397;
    height: 250px;
    margin-bottom: ${themeSpace(6)};
  }
  ${themeMediaQuery('md')} {
    width: 497px;
    height: 350px;
    margin-bottom: 0;
  }
`;

export const StyledOurStoryImage2 = styled(CloudImage)`
  border-radius: 32px 0px 0px 0px;
  position: absolute;
  ${themeMediaQuery('sm')} {
    width: 369px;
    height: 250px;
    margin-bottom: ${themeSpace(6)};
    top: 300px;
  }
  ${themeMediaQuery('md')} {
    width: 369px;
    height: 276px;
    top: 370px;
    left: 20px;
    margin-bottom: ${themeSpace(0)};
  }
`;

export const StyledOurStoryImage3 = styled(CloudImage)`
  border-radius: 0px 0px 0px 32px;
  position: absolute;
  ${themeMediaQuery('sm')} {
    width: 231px;
    height: 250px;
    margin-bottom: ${themeSpace(6)};
    top: 150px;
    right: 10px;
  }
  ${themeMediaQuery('md')} {
    width: 231px;
    height: 260px;
    top: 318px;
    right: 35px;
    margin-bottom: ${themeSpace(0)};
  }
`;

export const StyledOurStoryImage4 = styled(CloudImage)`
  border-radius: 0px 0px 0px 40px;
  position: absolute;
  width: 284px;
  ${themeMediaQuery('sm')} {
    height: 250px;
    top: 490px;
    right: 10px;
  }
  ${themeMediaQuery('md')} {
    height: 237px;
    top: 601px;
    right: 123px;
  }
`;

export const StyledStoriesPara = styled(Text)`
  max-width: 464px;
  ${themeMediaQuery('xl')} {
    max-width: 514px;
  }
`;

export const SignatureImage = styled(CloudImage)`
  width: 220px;
  height: 107px;
`;

export const ColumnsDescription = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    margin: ${themeSpace(10)} auto 0 auto;
  }
  ${themeMediaQuery('sm')} {
    margin: ${themeSpace(0)} auto 0 ${themeSpace(6)};
  }
  ${themeMediaQuery('md')} {
    margin: ${themeSpace(0)} auto 0 ${themeSpace(10)};
  }
`;
